module.exports = __webpack_public_path__ + "static/media/Charjabug_gaussian2.46ed10c2.png";